import type { ReactionSummaryDto } from '@/api/recognition';

/**
 * Emojis curados para reaccionar a un post-it (ver
 * docs/superpowers/specs/2026-08-04-reacciones-postit-design.md). El orden fijo también resuelve
 * empates en `pickTopReaction`.
 */
export const REACTION_EMOJIS = ['👏', '❤️', '😊', '🎉', '👍'] as const;

/** Emoji con más reacciones; empate se resuelve por el orden de `REACTION_EMOJIS`. `null` si no hay ninguna. */
export function pickTopReaction(counts: Record<string, number>): string | null {
  let top: string | null = null;
  let topCount = 0;
  for (const emoji of REACTION_EMOJIS) {
    const count = counts[emoji] ?? 0;
    if (count > topCount) {
      top = emoji;
      topCount = count;
    }
  }
  return top;
}

/**
 * Aplica localmente el resultado de un toggle de reacción — el mismo emoji la quita, otro la
 * reemplaza, ninguna previa la agrega. Usado por `useToggleReaction` (optimistic update); el mock
 * (y el futuro backend real) aplican la misma regla del lado del servidor.
 */
export function applyOptimisticToggle(
  current: ReactionSummaryDto | undefined,
  emoji: string,
): ReactionSummaryDto {
  const counts = { ...(current?.counts ?? {}) };
  const myReaction = current?.myReaction ?? null;
  let total = current?.total ?? 0;

  if (myReaction === emoji) {
    counts[emoji] = Math.max(0, (counts[emoji] ?? 0) - 1);
    return { counts, total: Math.max(0, total - 1), myReaction: null };
  }
  if (myReaction) {
    counts[myReaction] = Math.max(0, (counts[myReaction] ?? 0) - 1);
  } else {
    total += 1;
  }
  counts[emoji] = (counts[emoji] ?? 0) + 1;
  return { counts, total, myReaction: emoji };
}
